// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__DGzAx","container":"Contact_container__jdrvp","sub":"Contact_sub__FQds3","call":"Contact_call__GTPVi"};